import store from '@/store';
import { getStorageAuthInfo } from '@/utils/storageOperateApi';
import { LOCAL_STORAGE_KEY, SEARCH_TAB_TYPE, FIRST_PAGE_ENUM, SECOND_PAGE_ENUM_MAP } from '@/constants';

// 全局搜索 接口的搜索类型 转 tabType
export const SEARCH_TYPE_TO_TAB_TYPE = {
  3: SEARCH_TAB_TYPE.COMPANY, // 股票
  1: SEARCH_TAB_TYPE.ROADSHOW, // 路演
  13: SEARCH_TAB_TYPE.SUMMARY, // 纪要
  11: SEARCH_TAB_TYPE.COMMENT, // 点评
  7: SEARCH_TAB_TYPE.RESEARCH_CHART, // 研报图表
  2: SEARCH_TAB_TYPE.RESEARCH_REPORT, // 内资研报
  12: SEARCH_TAB_TYPE.OVERSEAS_REPORT, // 外资研报
  5: SEARCH_TAB_TYPE.STRATEGY, // 调研
  6: SEARCH_TAB_TYPE.QUESTION, // 问答
  10: SEARCH_TAB_TYPE.FINANCIAL_NEWS, // 资讯
  8: SEARCH_TAB_TYPE.ANALYST, // 分析师
  9: SEARCH_TAB_TYPE.SCHEDULE // 日程
  // 会议 需要单独处理，会议接口不使用全局搜索接口
};

/**
 * 全局搜索 tab 类型
 * @param queryParams 查询参数
 * @returns
 */
export function getGlobalSearchTabType(queryParams = {}) {
  const { type, tabType } = queryParams;
  return tabType || SEARCH_TYPE_TO_TAB_TYPE[type] || 0;
}

/**
 * 获取全局搜索 搜索id
 * @param queryParams 查询参数
 * @returns
 */
export function getGlobalSearchIdByType(queryParams = {}) {
  const finalTabType = getGlobalSearchTabType(queryParams);
  const firstPage = FIRST_PAGE_ENUM.GLOBAL_SEARCH; // 全局搜索
  const secondPage = SECOND_PAGE_ENUM_MAP[finalTabType] || '';
  const pageKey = `${firstPage}${secondPage ? `_${secondPage}` : ''}`;
  return store.getters.getGlobalSearchId(pageKey);
}

/**
 * 构建全局搜索埋点参数
 * @param queryParams 查询参数
 * @param userLoginIdentity 用户登录信息
 * @param searchId 搜索id
 * @returns
 */
export function buildGlobalSearchTrackParams(queryParams = {}, userLoginIdentity = {}, searchId = '') {
  const { name, orgName, shortOrgName } = userLoginIdentity;
  const finalTabType = getGlobalSearchTabType(queryParams);
  return {
    searchId, // 搜索id
    userName: name, // 用户名称
    orgName, // 所属机构
    shortOrgName, // 所属机构-简称
    tabType: finalTabType,
    firstPage: FIRST_PAGE_ENUM.GLOBAL_SEARCH, // 全局搜索
    secondPage: SECOND_PAGE_ENUM_MAP[finalTabType] || ''
  };
}

/**
 * 获取全局搜索埋点参数
 * @param queryParams 查询参数
 * @returns
 */
export function getGlobalSearchTrackParams(queryParams = {}) {
  const jmAuthInfo = getStorageAuthInfo(LOCAL_STORAGE_KEY.JM_AUTH_INFO, true);
  const jmUserLoginInfo = jmAuthInfo?.userinfo?.userLoginIdentity || {};
  return buildGlobalSearchTrackParams(queryParams, jmUserLoginInfo, getGlobalSearchIdByType(queryParams));
}

/**
 * 构建全局搜索接口耗时埋点配置
 * @param options 配置参数
 * @returns
 */
export function buildGlobalSearchCostTimeTrackConfig(options = {}) {
  const { needTrack = false, trackParams = {}, trackData = {} } = options;
  return {
    needTrack,
    trackParams: {
      statisticnum: 'GLOBAL_SEARCH.child.OTHER.child.REQUEST_COST_TIME',
      ...trackParams,
      ...trackData
    }
  };
}

/**
 * 获取全局搜索接口耗时埋点配置
 * @param options 配置参数
 * @returns
 */
export function getGlobalSearchCostTimeTrackConfig(options = {}) {
  const { needTrack = false, queryParams = {}, trackData = {} } = options;
  return buildGlobalSearchCostTimeTrackConfig({
    needTrack,
    trackParams: getGlobalSearchTrackParams(queryParams),
    trackData
  });
}
